import { useImportsTable } from "./useImportsTable";
import { Table } from "features/common/components/Table";
import { Box } from "@mui/material";

export const ImportsTable = () => {
  const { table, fileTsList } = useImportsTable();

  return (
    <>
      {fileTsList.length > 0 && (
        <Box
          sx={{ width: 540, height: 220, position: "absolute", bottom: 10 }}
          display="flex"
          alignItems="start"
        >
          <Table
            isPaginationShown={false}
            {...table}
            readonly
            displayBorder
            condensed={false}
          />
        </Box>
      )}
    </>
  );
};
